export enum NotificationValue {
  DocumetComment = 'Documet Comment',
  Clientuploaddocument = 'Client upload document',
  Adminrequesttouploaddocument = 'Admin request to upload document',
  AdminClientUploadLegal = 'Client upload legal document',
  Adminapproveddocument = 'Admin approved document',
  Adminrejectlegaldocument = 'Admin reject legal document',
  Adminapprovedlegaldocument = 'Admin approved legal document',
  Adminrejectdocument = 'Admin reject document',
  Adminuploadreportdocument = 'Admin upload report document',
}
